// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               v5.28.3
// source: host.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Empty } from "./google/protobuf/empty";

export const protobufPackage = "Cratis.Chronicle.Contracts.Host";

export interface ServerVersionInfo {
  Version: string;
  CommitSha: string;
  ProtocolVersion: string;
}

function createBaseServerVersionInfo(): ServerVersionInfo {
  return { Version: "", CommitSha: "", ProtocolVersion: "" };
}

export const ServerVersionInfo: MessageFns<ServerVersionInfo> = {
  encode(message: ServerVersionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Version !== "") {
      writer.uint32(10).string(message.Version);
    }
    if (message.CommitSha !== "") {
      writer.uint32(18).string(message.CommitSha);
    }
    if (message.ProtocolVersion !== "") {
      writer.uint32(26).string(message.ProtocolVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerVersionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseServerVersionInfo();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.Version = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.CommitSha = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.ProtocolVersion = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ServerVersionInfo {
    return {
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      CommitSha: isSet(object.CommitSha) ? globalThis.String(object.CommitSha) : "",
      ProtocolVersion: isSet(object.ProtocolVersion) ? globalThis.String(object.ProtocolVersion) : "",
    };
  },

  toJSON(message: ServerVersionInfo): unknown {
    const obj: any = {};
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.CommitSha !== "") {
      obj.CommitSha = message.CommitSha;
    }
    if (message.ProtocolVersion !== "") {
      obj.ProtocolVersion = message.ProtocolVersion;
    }
    return obj;
  },

  create(base?: DeepPartial<ServerVersionInfo>): ServerVersionInfo {
    return ServerVersionInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ServerVersionInfo>): ServerVersionInfo {
    const message = createBaseServerVersionInfo();
    message.Version = object.Version ?? "";
    message.CommitSha = object.CommitSha ?? "";
    message.ProtocolVersion = object.ProtocolVersion ?? "";
    return message;
  },
};

export type ServerDefinition = typeof ServerDefinition;
export const ServerDefinition = {
  name: "Server",
  fullName: "Cratis.Chronicle.Contracts.Host.Server",
  methods: {
    getVersionInfo: {
      name: "GetVersionInfo",
      requestType: Empty as typeof Empty,
      requestStream: false,
      responseType: ServerVersionInfo as typeof ServerVersionInfo,
      responseStream: false,
      options: {},
    },
    resetKernelState: {
      name: "ResetKernelState",
      requestType: Empty as typeof Empty,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface ServerServiceImplementation<CallContextExt = {}> {
  getVersionInfo(request: Empty, context: CallContext & CallContextExt): Promise<DeepPartial<ServerVersionInfo>>;
  resetKernelState(request: Empty, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
}

export interface ServerClient<CallOptionsExt = {}> {
  getVersionInfo(request: DeepPartial<Empty>, options?: CallOptions & CallOptionsExt): Promise<ServerVersionInfo>;
  resetKernelState(request: DeepPartial<Empty>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | bigint | undefined;

export type DeepPartial<T> = T extends bigint ? string | number | bigint
  : T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
